import { render, staticRenderFns } from "./buyGemsModal.vue?vue&type=template&id=653c3aa4&scoped=true&"
import script from "./buyGemsModal.vue?vue&type=script&lang=js&"
export * from "./buyGemsModal.vue?vue&type=script&lang=js&"
import style0 from "./buyGemsModal.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./buyGemsModal.vue?vue&type=style&index=1&id=653c3aa4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "653c3aa4",
  null
  
)

export default component.exports